/** 15_MOTION_AND_DELIGHT_SYSTEM §2–3. 값만 공유하고 구현은 플랫폼별로 분리한다 (MI-1/MI-2). */
export const duration = { instant: 80, fast: 160, base: 240, slow: 360, reward: 700 } as const;

export const easing = {
  standard: "cubic-bezier(0.22, 1, 0.36, 1)",
  enter: "cubic-bezier(0.16, 1, 0.3, 1)",
  exit: "cubic-bezier(0.4, 0, 1, 1)",
} as const;

export const spring = {
  pop:    { stiffness: 520, damping: 24, mass: 0.6 },
  bounce: { stiffness: 350, damping: 18, mass: 0.9 },
  sheet:  { stiffness: 350, damping: 25, mass: 1 },
} as const;

export const MOTION_TOKENS = ["POP","BOUNCE","STAMP","SPARKLE","WIGGLE","FLIP","CONFETTI"] as const;
export type MotionToken = (typeof MOTION_TOKENS)[number];

export const HAPTICS = ["light","selection","medium","heavy","success","error"] as const;
export type Haptic = (typeof HAPTICS)[number];

export const motionHaptic: Readonly<Record<MotionToken, Haptic | null>> = {
  POP: "light", BOUNCE: "light", STAMP: "heavy", SPARKLE: null,
  WIGGLE: null, FLIP: "selection", CONFETTI: "success",
};

/** Reduced Motion 대체. 사라지는 것이 아니라 정적 표현으로 번역한다 (NFR-M-02). */
export const reducedMotionAlternative: Readonly<Record<MotionToken, string>> = {
  POP: "색·배경 변화만",
  BOUNCE: "즉시 선택 상태 전환",
  STAMP: "회전 없는 페이드 인",
  SPARKLE: "정적 별 아이콘 1개",
  WIGGLE: "비활성",
  FLIP: "크로스페이드",
  CONFETTI: "정적 축하 카드 + 메시지",
};

/** PASSPORT_CROSSING — 8번째 토큰이 아니라 기존 4개의 순차 조합 (15 §3.8). */
export const PASSPORT_CROSSING = [
  { at: 0,   token: "STAMP"    as MotionToken, haptic: "heavy"   as Haptic },
  { at: 260, token: "BOUNCE"   as MotionToken, haptic: "light"   as Haptic },
  { at: 420, token: null,                      haptic: null, note: "arc reveal" },
  { at: 700, token: "CONFETTI" as MotionToken, haptic: "success" as Haptic },
] as const;
